import { Predicate } from '@ngxs/store/operators';

export function isNumber(value: any): value is number {
  return typeof value === 'number';
}

export function isObject(value: any): boolean {
  return typeof value === 'object';
}

export function isPredicate<T>(
  value: Predicate<T> | boolean | number | number[],
): value is Predicate<T> {
  return typeof value === 'function';
}

export function isArrayNumber(value: any[]): boolean {
  for (const i in value) {
    if (!isNumber(value[i])) {
      return false;
    }
  }
  return true;
}

export function isNullOrUndefined(value: any): boolean {
  return value === null || value === undefined;
}

export function defaultIfNullOrUndefined(value: any, defaultValue: any): any {
  return isNullOrUndefined(value) ? defaultValue : value;
}

export function invalidIndex(index: number): boolean {
  return Number.isNaN(index) || index < 0;
}

export function invalidIndexes<T>(
  indexes: number[],
  existing: Readonly<T[]>,
): boolean {
  for (const i in indexes) {
    if (
      !existing ||
      existing?.length - 1 < indexes[i] ||
      !isNumber(indexes[i]) ||
      invalidIndex(indexes[i])
    ) {
      return true;
    }
  }
  return false;
}

export function findIndexes<T>(
  predicate: Predicate<T>,
  existing: Readonly<T[]>,
): number[] {
  return existing.reduce((acc, it, i) => {
    const index = predicate(it as any) ? i : -1;
    return invalidIndex(index) ? acc : [...acc, index];
  }, []);
}
